import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import Tab from "./tab.jsx";
import SharedTab from "./sharedTab.jsx";
import styles from "../../common/tab-list.scss";
import tabStyles from "../../common/tab.scss";
import DashboardService from "../../../core/services/dashboardService.js";

export default class TabList extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      tabs: this.props.tabs,
      currentWidgetIndex: 0,
      dashboardState: []
    };
  }

  componentWillReceiveProps(nextProps) {
    let activeDashboardId;
    for (let i = 0; i < nextProps.tabs.length; i++) {
      if (nextProps.tabs[i].activated) {
        activeDashboardId = nextProps.tabs[i].persistenceId;
        break;
      }
    }
    if (isMobile() && activeDashboardId) {
      DashboardService.findDashboardStateByDashboardId(activeDashboardId)
        .then(res => {
          this.setState({
            tabs: nextProps.tabs,
            dashboardState: res.dashboardState
          });
        });
    } else {
      this.setState({
        tabs: nextProps.tabs,
      })
    }
  }

  componentDidMount() {
    this.dashboardIdToDelete = null;
    this.$tabList = $(this.refs.tabList);
    this.subscribe(InternalEvent.App.DOCUMENT_CLICKED, e => this.hideTabList(e));
    if (isMobile()) {
      DashboardService.getCurrentDashboard()
        .then(dashboard => {
          this.setState({
            dashboardState: dashboard.state.dashboardState,
          })
        });
    }
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  changeDashboard(dashboardId) {
    this.hideTabList(null, () => {
      this.props.onTabChange(dashboardId);
    });
    this.setState({currentWidgetIndex: 0});
  }

  changeWidget(index) {
    if (this.state.currentWidgetIndex !== index) {
      this.publish(InternalEvent.Dashboard.WIDGET_CHANGED, index);
      this.setState({
        currentWidgetIndex: index
      });
      this.hideTabList(null);
    } else {
      this.hideTabList(null);
    }
  }

  showTabList() {
    if (this.$tabList.attr("data-active") != "true") {
      this.props.onShowTab();
      this.$tabList.attr("data-active", true).velocity("slideDown", 500);
    } else {
      this.hideTabList(null);
    }
  }


  hideTabList(target, callback) {
    if (target !== null) {
      if ($(target).parents("#tab-container").length || $(target).parents(".modal").length) return;
    }

    this.$tabList.attr("data-active", false).velocity("slideUp", {
      duration: 500, complete() {
        if (typeof callback === "function") callback();
      }
    });
  }

  addDashboard() {
    let newDashboard = {
      title: "new dashboard",
      tabPosition: this.state.tabs.length,
      isNew: true
    };

    let tabs = this.state.tabs.slice();
    tabs.push(newDashboard);

    this.setState({
      tabs: tabs
    });
  }

  handleConfirm(dashboardId, position) {
    this.publish(InternalEvent.App.SHOW_APP_MODAL, {
      onAgree: () => {
        this.props.onDelete(dashboardId, position);
      },
      header: "Do you really want to remove?"
    });
  }

  render() {
    let widgetContainer, widgets = [], addBtn, dashboardListClasses = "dashboard-list row";
    let tabs = this.state.tabs.map((tab, index) => {
      return <Tab tab={tab} key={index}
                  onTitleChange={(id, title) => this.props.onUpdate(id, title)}
                  onDrop={(id, dropP, tabP) => this.props.onReposition(id, dropP, tabP)}
                  onAdd={(title, pos) => this.props.onAdd(title, pos)}
                  onTabClick={(id) => this.changeDashboard(id)}
                  onRemove={(id, pos) => this.handleConfirm(id, pos)}/>;
    });

    if (!isMobile()) {
      addBtn =
        <div className="tab-item col s6 m4">
          <div style={{display: "flex", padding: "8px 0"}}>
            <div className={tabStyles.title}>
              <i className={["icon-plus", tabStyles.addBtn].join(" ")} onClick={() => this.addDashboard()}/>
            </div>
          </div>
        </div>;
    } else {
      for (let i = 0; i < this.state.dashboardState.length; i++) {
        let itemStyle = "col s6 m4";
        if (this.state.currentWidgetIndex === i) {
          itemStyle = [itemStyle, tabStyles.activatedTitle].join(" ");
        } else {
          itemStyle = [itemStyle, tabStyles.title].join(" ");
        }
        widgets.push(<div className={itemStyle} key={"w-" + i} onClick={() => this.changeWidget(i)}>
          {this.state.dashboardState[i].widgetModel.title || "UNTITLED"}
        </div>)
      }
      widgetContainer = <div className="row" style={{margin: "10px 0 0 0"}}>
        <div className="col s12 mobile-tab-header">
          <div style={{textAlign: "center"}}>Widgets</div>
        </div>
        {widgets}
        <div className="col s12 mobile-tab-header" style={{marginTop: "15px"}}>
          <div style={{textAlign: "center"}}>Dashboards</div>
        </div>
      </div>;
      dashboardListClasses = "dashboard-list-mobile row";
    }

    return (
      <div className="">
        <div className={styles.toggle} onClick={() => this.showTabList()} data-active="false">
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
        <div className={styles.tabList} ref="tabList">
          <div className="row" style={{margin: 0}}>
            {widgetContainer}
            {tabs}
            {addBtn}
          </div>
          {
            this.props.shard.length > 0 ? <div>
              <div className={styles.share}>
                <div/>
                <div>SHARED</div>
              </div>
              <div className="row" style={{margin: 0}}>
                {
                  this.props.shard.map((tab, index) => {
                    return <SharedTab tab={tab} key={index} onTabClick={this.changeDashboard}
                                      onDrop={this.props.onReposition}
                                      onDelete={this.props.onSharedDashboardDeleted}
                                      onDashboardUpdate={this.props.onDashboardUpdate}/>
                  })
                }
              </div>
            </div> : null
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/tab/tabList.jsx